module.exports = __webpack_public_path__ + "img/login-t3.b8e0b1a5.png";